<template>
    <div class="date-picker">
        <b-row>
            <b-col>
                <b-form-group :label="label">
                    <b-input :value="time" @click.native="openTimePicker"></b-input>
                </b-form-group>
            </b-col>
        </b-row>

        <div class="selectors" @blur.native="open = false" v-if="open">
            <div class="hour-picker" v-if="!hour">
                <b-row>
                    <b-col align-self="center">
                        <app-sub-title text="Horas"></app-sub-title>
                    </b-col>
                </b-row>
                <b-row no-gutters class="am">
                    <b-col cols="2">AM</b-col>
                    <b-col cols="10">
                        <b-form-row>
                            <b-col
                                cols="2"
                                @click="setHour(i - 1)"
                                class="hour-selector"
                                v-for="i in 13"
                                :key="`am-${i}`"
                            >
                                <b-btn
                                    size="sm"
                                    variant="outline-primary"
                                    @click="setHour(i - 1)"
                                >{{hourLabel(i - 1)}}</b-btn>
                            </b-col>
                        </b-form-row>
                    </b-col>
                </b-row>
                <b-row no-gutters class="pm">
                    <b-col cols="2">PM</b-col>
                    <b-col cols="10">
                        <b-form-row>
                            <div v-for="i in 24" :key="`pm-${i}`">
                                <b-col v-if="i > 12" cols="2" class="hour-selector">
                                    <b-btn
                                        size="sm"
                                        variant="secondary"
                                        @click="setHour(i - 1)"
                                    >{{hourLabel(i - 1)}}</b-btn>
                                </b-col>
                            </div>
                        </b-form-row>
                    </b-col>
                </b-row>
            </div>
            <div class="minute-picker" v-if="!!hour">
                <b-row>
                    <b-col justify-center>
                        <app-sub-title text="Minutos"></app-sub-title>
                    </b-col>
                </b-row>
                <b-form-row>
                    <b-col cols="2" v-for="minute in minutes" :key="minute">
                        <b-btn
                            size="sm"
                            variant="outline-primary"
                            @click="selectMinutes(minute)"
                        >{{ `${minute}`.padStart(2, '0') }}</b-btn>
                    </b-col>
                </b-form-row>
            </div>
            <div class="d-flex justify-content-end">
                <b-btn variant="link" @click="open = false">Cerrar</b-btn>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'time_picker',
    props: {
        label: {
            type: String,
            default: '',
        },
        auto: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        hour: '',
        minute: '',
        open: false,
    }),
    watch: {
        open(val) {
            !val && this.$emit('input', this.realTime)
            !val && this.$emit('change', this.realTime)
        },
    },
    computed: {
        minutes() {
            const minutes = []

            for (let i = 0; i < 60; i += 5) {
                minutes.push(i)
            }

            return minutes
        },
        time() {
            if (!this.hour) return ''

            const m = this.hour < 12 ? 'AM' : 'PM'
            const h = this.hour - (this.hour > 12 ? 12 : 0)

            return `${h}:${this.minute} ${m}`
        },
        realTime() {
            if (!this.hour || !this.minute) return ''

            return `${this.hour}:${this.minute}:00`
        },
    },
    methods: {
        hourLabel(h) {
            const t = h - (h > 12 ? 12 : 0)

            return `${t}`.padStart(2, '0')
        },
        setHour(h) {
            this.hour = `${h}`.padStart(2, '0')
            this.minute = '00'
        },
        selectMinutes(m) {
            this.minute = `${m}`.padStart(2, '0')
            this.open = false
        },
        openTimePicker() {
            this.hour = ''
            this.minute = ''
            this.open = true
        },
        clearTimePicker() {
            this.hour = ''
            this.minute = ''
            this.open = false
        },
    },
    mounted() {
        if (this.auto && !this.value) {
            this.hour = moment().format('HH')
            this.minute = moment().format('mm')
            this.$emit('input', this.realTime)
            this.$emit('change', this.realTime)
        }

        if (!!this.value) {
            const patterns = {
                '^\\d{2}:\\d{2}$': 'HH:mm',
                '^\\d{2}:\\d{2}:\\d{2}$': 'HH:mm:ss',
            }

            const pattern = Object.keys(patterns).find(p =>
                new RegExp(p).test(this.value)
            )

            if (!pattern) return

            const time = moment(this.value, patterns[pattern])

            this.hour = time.format('HH')
            this.minute = time.format('mm')
        }
    },
    created() {
        this.$bus.$on('clearTimePicker', this.clearTimePicker)
    },
}

// const getHours = () => {
//     const hours = [];
//     for(i = 0; i < 24; i++) {
//         hours.push(i);
//     }
//     return hours;
// }
</script>
<style>
.date-picker {
    position: relative;
    z-index: 99;
}
.selectors {
    position: absolute;
    top: 70px;
    left: 0;
    background-color: white;
    border: 1px solid darkblue;
    border-radius: 4px;
    padding: 10px;
    width: 360px;
}
</style>